module.exports = __webpack_public_path__ + "img/avatar1.96ff53c9.jpg";